import React from 'react';

export default function HeroSection() {
  return (
    <section
      className="relative w-full overflow-hidden text-white text-center flex flex-col items-center justify-center min-h-[420px]"
      style={{
        background: 'linear-gradient(135deg, #0F2847 0%, #193D6D 40%, #2A5487 100%)',
        padding: '80px 40px'
      }}
      aria-labelledby="hero-title"
    >
      {/* Decorative elements */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
        <div className="absolute -top-32 -left-32 w-96 h-96 rounded-full opacity-[0.04]"
          style={{ background: 'radial-gradient(circle, #FCD34D, transparent)' }} />
        <div className="absolute -bottom-48 -right-48 w-[600px] h-[600px] rounded-full opacity-[0.03]"
          style={{ background: 'radial-gradient(circle, #FCD34D, transparent)' }} />
        {/* Grid pattern */}
        <div className="absolute inset-0 opacity-[0.03]"
          style={{ backgroundImage: 'linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)', backgroundSize: '60px 60px' }} />
      </div>

      <div className="relative max-w-4xl mx-auto flex flex-col items-center z-10">
        {/* Gold accent line */}
        <div className="w-12 h-[2px] bg-[#FCD34D] mb-8 opacity-80" style={{ animation: 'fadeIn 1s ease-out' }}></div>

        {/* Quote Block */}
        <blockquote className="mb-8 flex flex-col items-center" style={{ animation: 'fadeIn 0.8s ease-out' }}>
          <p className="text-[28px] md:text-[38px] italic font-light leading-tight mb-4 tracking-wide"
            style={{ fontFamily: "'Outfit', sans-serif", textShadow: '0 2px 20px rgba(0,0,0,0.15)' }}>
            "Todo contato deixa um vestígio."
          </p>
          <footer className="text-[14px] font-medium text-[#FCD34D]/80 uppercase tracking-[0.2em]">
            — Edmond Locard
          </footer>
        </blockquote>

        {/* Separator - Refined gold diamond */}
        <div className="flex items-center gap-4 my-6" style={{ animation: 'fadeIn 1.2s ease-out' }}>
          <div className="w-16 h-[1px] bg-gradient-to-r from-transparent to-[#FCD34D]/40"></div>
          <div className="w-2 h-2 rotate-45 bg-[#FCD34D]/60"></div>
          <div className="w-16 h-[1px] bg-gradient-to-l from-transparent to-[#FCD34D]/40"></div>
        </div>

        {/* Brand tagline */}
        <div className="mt-4" style={{ animation: 'fadeIn 1.4s ease-out' }}>
          <h1 id="hero-title" className="text-[18px] md:text-[22px] font-bold tracking-[0.15em] text-white uppercase mb-3"
            style={{ fontFamily: "'Outfit', sans-serif" }}>
            PROVATIO
          </h1>
          <p className="text-[13px] md:text-[15px] font-medium tracking-[0.1em] text-white/70 uppercase">
            Ciência, método e precisão a serviço da verdade
          </p>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 mt-10" style={{ animation: 'fadeIn 1.6s ease-out' }}>
          <a href="#modules"
            className="px-8 py-3.5 bg-[#FCD34D] text-[#193D6D] font-bold rounded-full shadow-lg shadow-[#FCD34D]/20 transition-all duration-300 hover:bg-[#FBBF24] hover:shadow-xl hover:shadow-[#FCD34D]/30 hover:-translate-y-0.5 text-sm tracking-wider uppercase"
            id="hero-cta-explore">
            Explorar Plataforma
          </a>
          <a href="/pt/system/login"
            className="px-8 py-3.5 border-2 border-white/30 text-white font-bold rounded-full transition-all duration-300 hover:bg-white/10 hover:border-white/60 hover:-translate-y-0.5 text-sm tracking-wider uppercase"
            id="hero-cta-login">
            Acessar Sistema
          </a>
        </div>
      </div>
    </section>
  );
}